import { useOutletContext } from 'react-router-dom';
import './Notification.css';

function Notification() {
  const { userData, onLogout } = useOutletContext();

  return (
    <div className="notification-page">
      <div className="notification-content">
        <div className="main-content-wrapper">
          <div className="notification-header">
            <h1 className="notification-title">Notification</h1>
          </div>
          <div className="notification-body">
            <p className="notification-placeholder">Notification content can be added here.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notification;
